import React from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet-async'
import { StaticQuery, graphql } from 'gatsby'

import Header from '../components/header'
import Footer from '../components/footer'
import Transition from '../components/transition'

import '../assets/scss/main.scss'

import favicon from '../assets/images/favicon.ico'
import ogImage from '../assets/images/ogimage.jpg'
import appleTouchIcon from '../assets/images/apple-touch-icon.png'
import favicon32 from '../assets/images/favicon-32x32.png'
import favicon16 from '../assets/images/favicon-16x16.png'
import safariPinnedTab from '../assets/images/safari-pinned-tab.svg'

const Layout = (props) => (
  <StaticQuery
    query={graphql`
      query {
        site {
          siteMetadata {
            title
            url
          }
        }
        allWpCategory {
          nodes {
            name
            slug
          }
        }
        allWpTag {
          nodes {
            name
            slug
          }
        }
      }
    `}
    render={(data) => {

      const { children, location, pageContext = {} } = props
      const path = (location && location.pathname) || ''

      return (
        <>
          <Helmet
            defaultTitle={`The Father Hood`}
            title={data.site.siteMetadata.title}
          >
            <html lang="en" />
            <link rel="shortcut icon" href={favicon} type="image/x-icon" />
            <link rel="apple-touch-icon" sizes="180x180" href={appleTouchIcon} />
            <link rel="icon" type="image/png" sizes="32x32" href={favicon32} />
            <link rel="icon" type="image/png" sizes="16x16" href={favicon16} />
            <link rel="mask-icon" href={safariPinnedTab} color="#ffffff" />
            <meta property="og:image:width" content="1200" />
            <meta property="og:image:height" content="630" />
            <meta property="og:image" content={ogImage} />
            <meta property="og:image:url" content={ogImage} />
            <meta property="og:type" content="website" />
            <meta property="og:title" content="The Father Hood - The hood for fathers." />
            <meta property="og:description" content="Helping dads to survive and thrive in the only job that really counts." />
            <meta property="og:site_name" content="The Father Hood" />
            <meta property="og:url" content={`${data.site.siteMetadata.url}${path}`} />
            <meta name="twitter:card" content="summary" />
            <meta name="twitter:description" content="Helping dads to survive and thrive in the only job that really counts." />
            <meta name="twitter:title" content="The Father Hood - The hood for fathers." />
          </Helmet>
          <Header
            title={pageContext.name || 'The Father Hood'}
            categories={data.allWpCategory.nodes}
          />
          <Transition location={location}>
            <main className="site-wrapper">
              { children }
            </main>
          </Transition>
          <Footer tags={data.allWpTag.nodes} />
        </>
      )
    }}
  />
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
